import React, { Component } from "react";
import { Link } from "react-router-dom";


import androidIcon from "../../images/web-icons/android-gray.svg";
import webIcon from "../../images/web-icons/web-app-gray.svg";
import apiIcon from "../../images/web-icons/api-gray.svg";

export default class ProjectItem extends Component {

  render() {
      const item = this.props.item;
    return (
      <div className="project-item">
        <div className="project-item-icon-container">
          <img src={item.icon} className="project-item-icon" />
        </div>
        <div className="project-item-next-to-icon">
          <label className="project-item-title">{item.title}</label>
          <label className="project-item-category">{item.category}</label>
        </div>
        <label className="project-item-description">
          {item.shortDescription}
        </label>
        <br />
        <br />
        {item.platform.android ? (
          <img
            src={androidIcon}
            className="project-item-platform-icon"
            title="Android"
          />
        ) : null}
        {item.platform.frontend ? (
          <img
            src={webIcon}
            className="project-item-platform-icon"
            title="Web"
          />
        ) : null}
        {item.platform.backend ? (
          <img
            src={apiIcon}
            className="project-item-platform-icon"
            title="API"
          />
        ) : null}

        <Link to={item.tag} className="project-item-learn-more">
          Learn more
        </Link>
      </div>
    );
  }
}
